import styled from 'styled-components';
import Typography from '@nubank/nuds-web/components/Typography/Typography';

export const CenteredText = styled(Typography)`
  max-width: 50rem;
`;

CenteredText.displayName = 'CenteredText';
